import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import Download from '../../atoms/icons/Download';
import { readableDateTime } from '../../../helpers/Date';
import Delete from '../../atoms/icons/Delete';
import { Link } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
const StyledTableCell = styled(TableCell) `
    min-width: 30px;
    flex: 0;

    svg {
        display: block;
        margin-left: auto;
    }

    &:hover {
        cursor: pointer;

        .icon {
            fill: ${props => props.theme.secondary};
        }
    }
`;
const StyledDownload = styled(Download) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;
`;
const StyledDeleteIcon = styled(Delete) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;
`;
const StyledDeleteButton = styled(({ asType: as, ...props }) => (_jsx(Link, { ...props, as: as }))) `
    background: transparent;
    border: 0;
    cursor: pointer;
    padding: 0;
`;
const FileTableRow = ({ file }) => {
    const { t } = useTranslation();
    return (_jsxs(TableRow, { children: [_jsx(TableCell, { label: t('file.label'), value: file.label }), _jsx(TableCell, { label: t('file.date'), value: readableDateTime(file.created_at) }), _jsx(StyledTableCell, { children: _jsx("a", { href: `/bestanden/${file.id}`, download: file.original_file_name, "aria-label": t('file.download'), children: _jsx(StyledDownload, { className: "icon" }) }) }), _jsx(StyledTableCell, { children: !file.protected && (_jsx(StyledDeleteButton, { href: `/bestanden/${file.id}`, method: "DELETE", "aria-label": t('file.delete'), asType: "button", onClick: (e) => window.confirm(t('file.delete_confirm')) ||
                        e.preventDefault(), children: _jsx(StyledDeleteIcon, { className: "icon" }) })) })] }));
};
export default FileTableRow;
